import { UnionTypeToConstant } from '@common-lib/utility-type/union.type';

type MainRouteType = 'dashboard' | 'denied';

export const MAIN_ROUTES: UnionTypeToConstant<MainRouteType> = {
  DASHBOARD: 'dashboard',
  DENIED: 'denied',
};
